import { selectSelfCompanies } from '@modules/auth/auth.Dux'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import Select from 'react-select-legacy'
import { compose } from 'redux'
import Consultations from '@services/Consultations'
import './MultiSelect.scss'

export class AsyncCustomerField extends Component {
  static defaultProps = {
    defaultSelectAll: false,
    meta: {},
    input: {
      value: null,
      onChange: () => null,
    },
  }

  state = {
    options: [],
  }

  //TODO: add CompanyAdmin restrictions once merged into PAAS
  fetchCustomers = (text) => {
    return Consultations.customer
      .index({
        page: 1,
        items_per_page: 7,
        search: text,
        companyFilter: this.props.selfCompanies.map((co) => co.api_key),
      })
      .then((response) => ({ options: response.data }))
  }

  render() {
    const { label, t } = this.props

    return (
      <div className="md-select-basic">
        {label && <label>{label}</label>}
        <div className={`md-multi-select`}>
          <Select.Async
            labelKey={'firstname'}
            valueKey={'id'}
            placeholder={t('Usuario')}
            value={this.props.input.value}
            loadOptions={this.fetchCustomers}
            onChange={this.props.input.onChange}
            removeSelected={false}
            filterOptions={(options) => options} // do not apply filters as they are already applied on backend
          ></Select.Async>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  selfCompanies: selectSelfCompanies(state),
})
export default compose(withTranslation(), connect(mapStateToProps))(AsyncCustomerField)
